'use client';
import React from 'react';

const BASE = 'https://cullertons-b4f8396.public.builtwithrocket.new';

const services = [
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
    num: '01',
    title: 'Bespoke & Personal',
    desc: "At Cullerton's, every client enjoys the dedicated expertise of a seasoned consultant who personally oversees the sale or purchase of their property from inception to completion\u2014without exception.",
    delay: 'delay-0',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
        <circle cx="12" cy="13" r="4" />
      </svg>
    ),
    num: '02',
    title: 'Award-Winning Marketing',
    desc: 'Our multiple award-winning service coupled with the finest marketing materials in Scotland, ensure that you gain a distinct advantage in an ever-evolving, international property market.',
    delay: 'delay-100',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    num: '03',
    title: 'Trust & Transparency',
    desc: 'You can rely on us to take care of everything. Our in-depth analysis and sharp grasp of market trends means you can always count on prudent, honest advice and sales success.',
    delay: 'delay-200',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
    num: '04',
    title: 'Local Market Acumen',
    desc: 'Stephen lives in the New Town. He knows the streets, the buyers, and what makes a home in EH3 exceptional. That local intelligence means your home is priced and positioned perfectly.',
    delay: 'delay-300',
  },
];

export default function ApproachSection() {
  return (
    <section id="approach" className="py-24 md:py-32 px-6 md:px-12 bg-cream">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-14 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="reveal">
            <span className="text-[11px] uppercase tracking-[0.2em] text-forest font-semibold block mb-3">Why Choose Cullerton&apos;s</span>
            <h2
              className="font-serif text-forest leading-[0.92] tracking-tight"
              style={{ fontSize: 'clamp(2.4rem, 5vw, 4.5rem)' }}
            >
              A different kind<br />
              <span className="italic text-gold">of estate agent.</span>
            </h2>
          </div>
          <p className="text-forest/60 max-w-sm leading-relaxed text-base reveal delay-100">
            SEAMLESS. We offer a highly personalised service, from viewings to negotiation, you will always deal directly with your senior consultant - no exceptions.
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {services?.map((s, i) => (
            <div
              key={i}
              className={`reveal ${s?.delay} rounded-3xl border border-forest/10 p-8 md:p-10 flex flex-col justify-between group hover:bg-forest hover:border-forest transition-all duration-500 ${
                i < 2 ? 'md:min-h-[280px]' : 'md:min-h-[220px]'
              }`}
            >
              <div className="flex justify-between items-start mb-6">
                <div className="w-12 h-12 rounded-2xl bg-sage/15 group-hover:bg-sage/25 flex items-center justify-center text-sage group-hover:text-sage-light transition-colors">
                  {s?.icon}
                </div>
                <span className="font-serif text-4xl text-forest/10 group-hover:text-cream/10 transition-colors leading-none">{s?.num}</span>
              </div>
              <div>
                <h3 className="font-sans text-2xl text-forest group-hover:text-cream mb-3 transition-colors uppercase tracking-[0.15em]">{s?.title}</h3>
                <p className="text-forest/60 group-hover:text-cream/60 transition-colors text-base">{s?.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Awards + Team */}
        <div className="mt-10 rounded-3xl bg-[#3F5948] overflow-hidden flex flex-col md:flex-row reveal delay-300" style={{ minHeight: '220px' }}>
          <div className="flex-[50] flex items-center justify-center px-8 py-8">
            <img
              src={`/assets/images/Cullerton_s_awards-1776860808171.png`}
              alt="Cullerton's award banners: Scotland Prestige Awards 2020-2021 and 2021-2022, The Herald Property Awards 2021-2022, Scotland Business Awards 2023, British Property Awards Gold 2024 and 2025"
              className="w-full h-auto object-contain max-h-[200px]"
            />
          </div>
          <div className="flex-[50] relative min-h-[220px]">
            <img
              src={`/assets/images/Cullertons-team_wider_image-1776860772677.jpg`}
              alt="Cullerton's team — members smiling together in a wide landscape photo"
              className="absolute inset-0 w-full h-full object-cover rounded-r-3xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
